import { createContext, useState, useCallback } from "react";

const FormContext = createContext(null);

export const FormProvider = ({ children }) => {
  const [savedFormData, setSavedFormData] = useState({});
  const [emp_id, setEmpId] = useState(null);
  const [status, setStatus] = useState("idle"); // idle | saving | saved | error

  const saveFormData = useCallback((data) => {
    setSavedFormData((prev) => ({ ...prev, ...data }));
    if (data.emp_id) setEmpId(data.emp_id);
  }, []);

  const clearFormData = useCallback(() => {
    setSavedFormData({});
    setEmpId(null);
    setStatus("idle");
  }, []);

  const setDraftId = useCallback((id) => {
    setEmpId(id);
  }, []);

  return (
    <FormContext.Provider
      value={{
        savedFormData,
        emp_id,
        status,
        saveFormData,
        clearFormData,
        setDraftId,
        setStatus,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

export default FormContext;
